var _defs, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.16,27.52c2,0,3.63,1.62,3.63,3.62s-1.63,3.62-3.63,3.62-3.63-1.62-3.63-3.62,1.63-3.62,3.63-3.62m0-3c-3.66,0-6.63,2.96-6.63,6.62s2.97,6.62,6.63,6.62,6.63-2.96,6.63-6.62-2.97-6.62-6.63-6.62h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.85,27.6c2,0,3.63,1.62,3.63,3.62s-1.63,3.62-3.63,3.62-3.63-1.62-3.63-3.62,1.63-3.62,3.63-3.62m0-3c-3.66,0-6.63,2.96-6.63,6.62s2.97,6.62,6.63,6.62,6.63-2.96,6.63-6.62-2.97-6.62-6.63-6.62h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.41,40.92c6.13,1.94,10.26,5.55,10.26,9.63h7c.46,0,.83-.37.83-.83v-2.15c0-3.93-6.01-7.12-13.34-7.12-1.67,0-3.27.16-4.75.47h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.48,50.63c0-4.01,4-7.7,9.97-9.66h0c-1.44-.28-2.98-.44-4.6-.44-7.33,0-13.35,3.19-13.35,7.12v2.15c0,.46.37.83.83.83h7.15Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m16.67,53.22c0-6.16,9.42-11.15,20.91-11.15s20.9,4.99,20.9,11.15v3.37c0,.72-.58,1.3-1.3,1.3H17.97c-.72,0-1.3-.58-1.3-1.3v-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.59,20.11c4.07,0,7.39,3.31,7.39,7.37s-3.31,7.37-7.39,7.37-7.39-3.31-7.39-7.37,3.31-7.37,7.39-7.37m0-3c-5.74,0-10.39,4.64-10.39,10.37s4.65,10.37,10.39,10.37,10.39-4.64,10.39-10.37-4.65-10.37-10.39-10.37h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/__Groups.32015e8751c58faca1ca8e60c51edfc9.svg";
export { ForwardRef as ReactComponent };